
module.exports = {
	webp: require(`./imgop_background.webp`),
	jp2: require(`./imgop_background.jp2`),
	fallback: require(`./imgop_background.jpg`),
}
